import { useContext } from "react";
import { SSOContext } from "./SSOContext.js";
import { SSOContextReducerActions } from "./constants.js";
import "react/jsx-runtime";
import "../../utils/noOp.js";
function useSSO() {
  const { state, dispatch } = useContext(SSOContext), { currentUser, apps } = state;
  function setCurrentUser(user) {
    dispatch({ type: SSOContextReducerActions.SetCurrentUser, payload: user });
  }
  function setApps(apps2) {
    dispatch({ type: SSOContextReducerActions.SetApps, payload: apps2 });
  }
  function logOut() {
    dispatch({ type: SSOContextReducerActions.LogOut });
  }
  function initSSO(message) {
    const { responseDetails } = message, { isAuthenticated, currentUser: currentUser2, clientPortals } = responseDetails;
    isAuthenticated && currentUser2 && setCurrentUser(currentUser2), clientPortals && setApps(clientPortals);
  }
  return { setCurrentUser, setApps, logOut, currentUser, apps, initSSO };
}
export {
  useSSO
};
//# sourceMappingURL=useSSO.js.map
